import React from 'react';
import {
	BodyContainer,
	Container
} from '../components/StyledComponents/StyledComponents';
import Navigation from '../components/Navigation/Navigation.jsx';
import Footer from '../components/Footer/Footer.jsx';
import ProgressBar from '../components/ProgressBar/ProgressBar';
import { PALETTE_3 } from '../assets/colors';

import { useEffect, useState } from 'react';

import { db } from '../firebase.js';
import { collection, onSnapshot } from "firebase/firestore"; 

import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

const Hiking = () => {
	const [input, ]=useState('');
    const [list, setList]=useState([]);
	const [miles, setMiles] = useState(0);
	const [elevationGain, setElevationGain] = useState(0);
	const [selectedYear, setSelectedYear] = useState('all');
	const [years, setYears] = useState([]);

	useEffect(() => {
		setList([]); // Reset list to avoid duplicates
		setMiles(0); // Reset miles
		setElevationGain(0); // Reset elevation gain
        onSnapshot(collection(db, 'hiking'), (snapshot) => {
            snapshot.docs.forEach(doc => {
                let data = doc.data();
                setList(prev => [...prev, data]);
				setMiles(miles => miles + (data.miles || 0));
				setElevationGain(gain => gain + (data.elevationGain || 0));
            });
			
			// Get unique years from timestamps
			const uniqueYears = [...new Set(snapshot.docs.map(doc => {
				const date = doc.data().timestamp.toDate();
				return date.getFullYear();
			}))].sort((a, b) => b - a);
			setYears(uniqueYears);
        });
    }, [input]);

	const filteredHikes = selectedYear === 'all' 
		? list 
		: list.filter(hike => {
			const hikeYear = hike.timestamp.toDate().getFullYear();
			return hikeYear === parseInt(selectedYear);
		});

    return (
		<>
			<ProgressBar />
			<Navigation page="about" />
			<BodyContainer style={{margin: "10%"}}>
				<h1>Mountains</h1>
				
				{/* Stats Section */}
				<Container style={{
					background: 'rgba(255, 255, 255, 0.05)',
					padding: '2rem',
					borderRadius: '8px',
					marginBottom: '2rem',
					display: 'flex',
					justifyContent: 'space-around',
					flexWrap: 'wrap',
					gap: '2rem'
				}}>
					<div style={{textAlign: 'center'}}>
						<h2 style={{margin: 0, color: PALETTE_3.THISTLE}}>{list.length}</h2>
						<p style={{margin: '0.5rem 0'}}>Mountains Climbed</p>
					</div>
					<div style={{textAlign: 'center'}}>
						<h2 style={{margin: 0, color: PALETTE_3.THISTLE}}>{Math.round(miles)}</h2>
						<p style={{margin: '0.5rem 0'}}>Miles Hiked</p>
					</div>
				</Container>

				{/* Year Filter
				<div style={{
					marginBottom: '2rem',
					display: 'flex',
					alignItems: 'left',
					justifyContent: 'left',
					gap: '1rem',
					background: 'rgba(255, 255, 255, 0.05)',
					padding: '1rem',
					borderRadius: '8px',
				}}>
					<h3 style={{ margin: 0, fontSize: '1.1rem' }}>Filter by Year:</h3>
					<select 
						value={selectedYear} 
						onChange={(e) => setSelectedYear(e.target.value)}
						style={{
							padding: '0.75rem 1.5rem',
							borderRadius: '4px',
							background: PALETTE_3.THISTLE,
							color: 'white',
							border: 'none',
							cursor: 'pointer',
							fontSize: '1rem',
							fontWeight: '500',
							appearance: 'none',
							WebkitAppearance: 'none',
							MozAppearance: 'none',
							backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'right 0.7rem center',
							backgroundSize: '1em',
							paddingRight: '2.5rem',
							transition: 'all 0.2s ease',
							':hover': {
								filter: 'brightness(110%)'
							}
						}}
					>
						<option value="all" style={{background: '#fff', color: '#000'}}>All Years</option>
						{years.map(year => (
							<option key={year} value={year} style={{background: '#fff', color: '#000'}}>{year}</option>
						))}
					</select>
					{selectedYear !== 'all' && (
						<button
							onClick={() => setSelectedYear('all')}
							style={{
								padding: '0.75rem',
								borderRadius: '4px',
								background: 'rgba(255, 255, 255, 0.1)',
								border: 'none',
								color: 'white',
								cursor: 'pointer',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								transition: 'all 0.2s ease',
							}}
							title="Clear filter"
						>
							✕
						</button>
					)}
				</div> */}

				<VerticalTimeline>
				{filteredHikes.sort((a,b) => b.timestamp.seconds - a.timestamp.seconds).map((hike, index) => {
					return (
						<VerticalTimelineElement
							key={index}
							className="vertical-timeline-element--work"
							date={hike.date}
							iconStyle={{ background: PALETTE_3.THISTLE, color: '#fff' }}
						>
							<h3 className="vertical-timeline-element-title">{hike.name}</h3>
							{/* <div style={{
								display: 'flex',
								gap: '1rem',
								fontSize: '0.9em',
								color: 'rgba(255, 255, 255, 0.7)',
								marginBottom: '1rem'
							}}>
								{hike.miles && <span>{hike.miles} miles</span>}
								{hike.elevationGain && <span>{hike.elevationGain}ft gain</span>}
							</div> */}
							<p>{hike.desc}</p>
							{hike.image && (
								<div style={{
									position: 'relative',
									width: '100%',
									paddingTop: '56.25%', // 16:9 aspect ratio
									marginTop: '1rem',
									borderRadius: '4px',
									overflow: 'hidden'
								}}>
									<img 
										src={hike.image} 
										alt={hike.name} 
										style={{
											position: 'absolute',
											top: 0,
											left: 0,
											width: '100%',
											height: '100%',
											objectFit: 'cover',
											borderRadius: '4px'
										}}
									/>
								</div>
							)}
						</VerticalTimelineElement>
					)
				})}
				</VerticalTimeline>
			</BodyContainer>
			<Footer />
		</>
    );
}

export default Hiking;